import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uk-padding uk-width-1-1" }
const _hoisted_2 = { class: "uk-container" }
const _hoisted_3 = {
  class: "",
  "data-uk-grid": ""
}
const _hoisted_4 = { class: "uk-width-3-5@xl uk-width-3-5@l uk-width-1-1@m" }
const _hoisted_5 = { class: "uk-margin-remove" }
const _hoisted_6 = { class: "uk-text-muted impx-text-large uk-margin-remove" }
const _hoisted_7 = { class: "impx-text-large" }
const _hoisted_8 = { class: "uk-width-2-5@xl uk-width-2-5@l uk-width-1-1@m" }
const _hoisted_9 = { class: "uk-card uk-card-default uk-card-small uk-margin-bottom" }
const _hoisted_10 = { class: "uk-card-body" }
const _hoisted_11 = ["src"]



export default /*@__PURE__*/_defineComponent({
  __name: 'CsaDesc',
  props: {
  aboutInfos:{}
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(props.aboutInfos?.title), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(props.aboutInfos?.subttitle), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(props.aboutInfos?.description[0]??''), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.aboutInfos?.description??[], (desc, index) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "uk-margin-bottom data-uk-dropcap",
              key: index
            }, _toDisplayString(props.aboutInfos?.description[index+1]), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: props.aboutInfos?.image?.url,
                alt: "room-3"
              }, null, 8, _hoisted_11)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})